import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { DocumentTemplate, DocumentTemplateDetails, SaveDocumentTemplate } from './document-template-administration-model';

@Injectable({
  providedIn: 'root'
})
export class DocumentTemplateAdministrationService {

  constructor(private appServerAPI: AppServerAPI) { }

  public loadTemplates(): Observable<DocumentTemplate[]> {
    return this.appServerAPI.execute('/tmc-common/processing/document-template-admin/templates', {});
  }

  public loadDetails(templateId: number): Observable<DocumentTemplateDetails> {
    return this.appServerAPI.execute('/tmc-common/processing/document-template-admin/details', templateId);
  }

  public deleteTemmplate(templateId: number): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/tmc-common/processing/document-template-admin/delete', templateId);
  }

  public saveDetails(details: SaveDocumentTemplate): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/tmc-common/processing/document-template-admin/save', details);
  }
}
